import { builtInButtons } from '../../default-tour-options';


export const steps = [
  {

    buttons: [
      builtInButtons.cancel,
      builtInButtons.next
    ],
    classes: 'custom-class-name-1 custom-class-name-2',
    id: 'intro',
    title: 'Creating a Job',
    text: `
          <p>This page is used to create new jobs for tapes to be processed against.</p>
          <p>Depending on the features enabled on your Investigo system, different options may be available when creating a job.</p>
          <p>These features are different job types and the ability to preload jobs with manifests of tapes (either barcode and / or serial numbers).</p>
          `
  }  
];
